// Updates all the anchor tags with UTMs coming from Android/iOS apps

function updateTrackingParams() {
  const productLinks = document.querySelectorAll('.products-overview__grid-item a');
  const params = new URLSearchParams(window.location.search);
  if (params.size <= 1) {
    return;
  }

  const UTMSource = params.get('utm_source');
  const UTMMedium = params.get('utm_medium');
  const UTMId = params.get('utm_id');

  for (let i = 0; i < productLinks.length; i++) {
    const productLink = productLinks[i];
    const productUrl = productLink.getAttribute('href');
    const trackingUrlParams = new URLSearchParams();

    if (UTMSource) {
      trackingUrlParams.set('utm_source', UTMSource);
    }

    if (UTMMedium) {
      trackingUrlParams.set('utm_medium', UTMMedium);
    }

    if (UTMId) {
      trackingUrlParams.set('utm_id', UTMId);
    }

    const newTrackingParams = trackingUrlParams.toString();
    const newHref = `${productUrl}&${newTrackingParams}`;

    productLink.setAttribute('href', newHref);
  }
}

if (document.body.classList.contains('mobile-shop')) {
  updateTrackingParams();
}
